import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {GameService} from '../../services/game.service'; // Adjust path as per your project structure
import {Router} from '@angular/router';
import {AuthService} from "../../services/auth.service";
import Swal from "sweetalert2";
import {isEconetSubscriberValidator, validPhoneNumber} from "../../utils/utils/validators/CustomValidators";

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {
    loginForm!: FormGroup;
    isPasswordVisible: boolean = false;
    isVerified: boolean = false;
    noPhone: boolean = false;
    isGettingOtp: boolean = false;
    constructor(
        private fb: FormBuilder,
        private gameService: GameService,
        private router: Router,
        private _authService: AuthService
    ) {
    }

    ngOnInit(): void {
        this.loginForm = this.fb.group({
            identifier: ['', [Validators.required, Validators.minLength(10), Validators.maxLength(10), isEconetSubscriberValidator()]],
            password: ['', [Validators.required]],
            otp: ['', [Validators.required]]
        });
    }

    onSubmit(): void {
        console.log(this.loginForm.value);
        if (this.loginForm.valid) {
            const formValue = this.loginForm.value;
            const payload = {
                email: this.isEmail(formValue.identifier) ? formValue.identifier : '',
                phoneNumber: this.isEmail(formValue.identifier) ? '' : formValue.identifier,
                otp: formValue.otp,
                password: formValue.password
            };

            this._authService.login(payload).subscribe(
                response => {
                    if (response.success) {

                        Swal.fire("SignIn Success!", "Proceed next", "success").then(() =>
                            this.router.navigate(['/games']) // Redirect to login page or another page
                        );
                    } else {
                        Swal.fire("SignIn Failed!", response.message, "error").then(() =>
                            this.router.navigate(['/login'])
                        );
                    }
                },
                error => {
                    Swal.fire("Error occurred", error.message, "error").then(() =>
                        this.router.navigate(['/signup'])
                    );
                }
            );
        } else {
          console.log("We displaying error for opt");
          // Validation failed or OTP not received
          // this.displayOTPError = this.gotOTP && this.loginForm.get('otp')?.invalid;
          this.loginForm.markAllAsTouched(); // This will trigger the display of all validation messages
        }
    }

    private isEmail(identifier: string): boolean {
        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(identifier);
    }

    getOTP() {
        if (this.isGettingOtp) {
            Swal.fire("Getting OTP", "Please wait...", "info");
            return;
        }

        // this.displayOTPError=false;
        if (this.loginForm.value.identifier === '' || !validPhoneNumber(this.loginForm.value.identifier)) {
            this.noPhone = true;
        } else {
          this.noPhone = false;
            this.isGettingOtp = true;
            // this.gotOTP=true;
            console.log("Getting otp ... now");
            const formValue = this.loginForm.value;
            const payload = {
                email: this.isEmail(formValue.identifier) ? formValue.identifier : '',
                phoneNumber: this.isEmail(formValue.identifier) ? '' : formValue.identifier,
            };
            this._authService.sendOTP(payload).subscribe(
                (data) => {
                    if (data.success) {
                        Swal.fire("OTP sent Successfully!", "Check OTP message", "success");
                        this.isVerified = true;
                    } else {
                        Swal.fire("Failed to send OTP", data.message, "error");
                        this.isVerified = false;

                    }
                    this.isGettingOtp = false;
                }
                , error => {
                    Swal.fire("Failed to send OTP ", "An Error occurred contact support", "error");
                    this.isGettingOtp = false;
                }
            );
        }
    }

    routeToPage(page: string) {
        this.router.navigate([page])
    }

    togglePasswordVisibility(): void {
        this.isPasswordVisible = !this.isPasswordVisible;
    }
}
